module.exports = {
      id: "charge-low-usage",
      viewBox: "0 0 16 11",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#charge-low-usage",
      toString: function () {
        return this.url;
      }
    }